import '../CsvJsonInfoPages.scss';


function MileageCalculation() {
    return (
        <div className='csv-json-info-pages-container'>
            <h1>Used Values - Mileage Calculation</h1>
            <p>Calculation of a price for a required mileage which lies between two given mileages is done using linear interpolation (see examples). Both High and Low mileage variations are now published in the ASCII files.
                Calculations should not be attempted above or below the given mileages.</p>
            <b>Formula</b>

            <p>
                To calculate a valuation (V) for a custom mileage (M), where<br />
                (V1,M1) are (price, mileage) for low mileage, and<br />
                (V2, M2) are (price, mileage) for high mileage....<br /><br />

                P = truncate((V1 - V2) / (M2 - M1))<br /><br />

                V = V1 - P*(M - M1)<br /><br />

                NB: truncate(x) returns the largest integer which is not greater than x<br /><br />

                Eg. truncate(2.33) = 2, truncate(5.99) = 5
            </p>


            <b>Example 1</b>
            <p>
                Mileage 1 = 5 (thousand) Price = 7000<br />
                Mileage 2 = 15 (thousand) Price = 6575<br />
                Mileage required = 10 (thousand)<br />
                Price difference per 1000 miles = (7000 - 6575) / 10 = 42.5 But this figure is truncated to 42<br />
                The Price is always calculated from the lowest mileage.<br />
                Price = 7000 - (42 * 5) = 6790. These are unrounded figures (raw data).
            </p>


            <b>Example 2</b>
            <p>Mileage 1 = 60 (thousand) Price = 5975<br />
                Mileage 2 = 100 (thousand) Price = 4550<br />
                Mileage required = 75 (thousand)<br />
                Price difference per 1000 miles = (5975 - 4550) / 40 = 35.625 But this figure is truncated to 35<br />
                The Price is always calculated from the lowest mileage.<br />
                Price = 5975 - (35 * 15) = 5450. These are unrounded figures (raw data).
            </p>

            <b>Example 3</b>
            <p>Mileage 1 = 130 (thousand) Price = 1050<br />
                Mileage 2 = 150 (thousand) Price = 930<br />
                Mileage required = 135 (thousand)<br />
                Price difference per 1000 miles = (1050 - 930) / 20 = 6 But this figure is truncated to 6<br />
                The Price is always calculated from the lowest mileage.<br />
                Price = 1050 - (6 * 5) = 1020. These are unrounded figures (raw data).
            </p>

            <b>ROUNDING CALCULATIONS</b>
            <p>To obtain the rounded (final) price the following rules are used :</p>

            <b>Trade Prices - Clean, Average, Below</b>
            <p>Up to £1000 - Nearest £10<br />
                Up to £10,000 - Nearest £25<br />
                Up to £30,000 - Nearest £50<br />
                Over £30,000 - Nearest £100
            </p>

            <b>Retail Price</b>
            <p>Up to £10,000 - Nearest £25 then<br />
                xx00 -&gt; xx00 - 5<br />
                x025 -&gt; x025 - 30<br />
                x050 -&gt; x050 + 45<br />
                x075 -&gt; x075 + 20<br /><br />

                Up to £20,000 - Nearest £50 then<br /><br />

                xxx00 -&gt; xxx00 - 5<br />
                xx050 -&gt; xx050 + 45<br /><br />

                Over £20,000 - Nearest £250</p>

            <p><u><b>Please note:</b></u></p>
            <p>The following formulas should be used for each of the ‘Nearest £x’ rules:<br />
                Nearest £10       truncate((price + 5) / 10) * 10<br />
                Nearest £25       truncate((price + 13) / 25) * 25<br />
                Nearest £50       truncate((price + 25) / 50) * 50<br />
                Nearest £100     truncate((price + 50) / 100) * 100<br /><br />

                NB: truncate(x) returns the largest integer which is not greater than x<br /><br />

                Eg. truncate(2.33) = 2,<br /><br />

                truncate(5.99) = 5
            </p>
        </div>
    );
}

export default MileageCalculation;
